import React, {useEffect} from 'react';
import styles from './styles.module.scss';
import {CustomQueryClientProvider} from '../../../hooks/useQueryClientProvider';
import {Dialog, DialogTitle} from '@priority-software/priority-style-react';
import usePortal from 'react-useportal';
import Footer from './Footer';
import {CloseWithHelp} from '../../ReportGenerator/componenets/CloseWithHelp';
import texts from '../texts';
import {
    showHelpMessage,
    showHelpWithLinksMessage
} from '../../../_shared/Messages/actions/MessageActions';
import Content from './Content';
import {partsStore} from '../PartsStore';
import {
    PARTS_SEARCH_MONITOR,
    PARTS_SEARCH_MONITOR_ADD,
    PART_CHECKBOX_NAME,
    SEARCH_BUTTON_NAME,
    SEARCH_INPUT_NAME
} from '../consts';
import {objectifyParts} from '../utils';
import {handlePartModalInsertion} from '../../../_shared/GWTBridge/invoke/netForm';
import {useEventListener} from 'usehooks-ts';
import keyCodes from '../../../constants/KeyCodes';
import {setIsNavigationEnabled} from '../../../_shared/GWTBridge/invoke/genPage';
import {IsJsonString} from '../../../utils/proto-api-utils/utils';
import {sendMonitor} from '../../../utils/monitoring';

interface Props {
    onClose: () => void;
    isOpen: boolean;
    formName: string;
    hasTquantField: () => boolean;
}

const PartsDialogComp = (props: Props) => {
    const {isOpen, onClose, formName, hasTquantField} = props;
    const handleHelp = () => {
        if (!IsJsonString(texts.help)) {
            showHelpMessage(texts.help);
            return;
        }

        const help = JSON.parse(texts.help);
        const {HyperLinks, text} = help?.[0];

        const links = HyperLinks.map(({ename, ...link}) => ({
            ...link,
            linkData: {ename}
        }));

        showHelpWithLinksMessage(text, links);
    };

    const {clearData, selectedItems} = partsStore;

    const hasTquant = hasTquantField();

    const handleKeyDown = (e: KeyboardEvent) => {
        if (
            e.keyCode === keyCodes.ENTER &&
            !!selectedItems?.size &&
            !(document.activeElement.getAttribute('name') === SEARCH_INPUT_NAME) &&
            !(document.activeElement.getAttribute('name') === SEARCH_BUTTON_NAME) &&
            !(document.activeElement.getAttribute('name') === PART_CHECKBOX_NAME)
        ) {
            handleConfirm();
        }
    };
    useEventListener('keydown', handleKeyDown);

    useEffect(() => {
        setIsNavigationEnabled(false);

        return () => {
            setIsNavigationEnabled(true);
        };
    }, []);

    const handleClose = () => {
        onClose();
        clearData();
    };

    const handleConfirm = () => {
        const selectedItemsObj = objectifyParts(selectedItems);
        handlePartModalInsertion(selectedItemsObj, 0);
        handleClose();
        sendMonitor(`${PARTS_SEARCH_MONITOR}${PARTS_SEARCH_MONITOR_ADD}`);
    };

    return (
        isOpen && (
            <Dialog
                closable
                componentClasses={styles.dialog}
                isOpen={true}
                onClose={handleClose}
                closeIcon={<CloseWithHelp onHelp={handleHelp} />}
                title={
                    <DialogTitle
                        componentClasses={styles.DialogTitle}
                        skin="h3"
                        title={texts.dialogTitle}
                    />
                }
                content={<Content formName={formName} hasTquant={hasTquant} />}
                footer={<Footer onConfirm={handleConfirm} onClose={handleClose} />}
            />
        )
    );
};

const PartsDialog = (props: Props) => {
    const {Portal} = usePortal();

    return (
        <Portal>
            <CustomQueryClientProvider>
                {props.isOpen && <PartsDialogComp {...props} />}
            </CustomQueryClientProvider>
        </Portal>
    );
};

export default PartsDialog;
